"use client";

import type { AttachmentStats, BaseStats } from "@/types/weapon";

interface WeaponStatsProps {
  baseStats: BaseStats;
  attachmentStats?: AttachmentStats[];
}

export function WeaponStats({
  baseStats,
  attachmentStats = [],
}: WeaponStatsProps) {
  // Calculate total stats with attachments
  const totalStats = { ...baseStats };
  for (const attachmentStat of attachmentStats) {
    totalStats.damage += attachmentStat.damage;
    totalStats.rof += attachmentStat.rof;
    totalStats.mag += attachmentStat.mag;
    totalStats.hipfire += attachmentStat.hipfire;
    totalStats.precision += attachmentStat.precision;
    totalStats.ads += attachmentStat.ads;
    totalStats.reload += attachmentStat.reload;
    totalStats.velocity += attachmentStat.velocity;
  }

  const statConfig = [
    { key: "damage", label: "DAMAGE", max: 100 },
    { key: "rof", label: "FIRE RATE", max: 1000 },
    { key: "control", label: "CONTROL", max: 100 },
    { key: "mobility", label: "MOBILITY", max: 100 },
  ];

  return (
    <div className="relative">
      {/* Blurred Stats Content */}
      <div className="flex flex-col gap-3 blur-sm">
        {statConfig.map((stat) => (
          <div className="flex items-center gap-3.5" key={stat.key}>
            <span className="w-[82px] font-mono text-[#8B9297] text-[11px] tracking-wide">
              {stat.label}
            </span>
            <div className="h-2 flex-1 rounded bg-[#0C0D0E]">
              <div
                className="h-2 rounded bg-[#F5A23E]"
                style={{
                  width: `${Math.min(100, (totalStats[stat.key as keyof typeof totalStats] / stat.max) * 100)}%`,
                }}
              />
            </div>
            <span className="w-8 text-right font-mono text-[#EAEBEC] text-xs">
              {totalStats[stat.key as keyof typeof totalStats]}
            </span>
          </div>
        ))}
      </div>

      {/* Coming Soon Overlay */}
      <div className="absolute inset-0 flex items-center justify-center bg-[#141618]/50 backdrop-blur-[1px]">
        <div className="text-center">
          <h3 className="mb-1 font-semibold text-[#EAEBEC] text-lg">
            Coming Soon
          </h3>
          <p className="text-[#8B9297] text-sm">
            Weapon stats will be available soon
          </p>
        </div>
      </div>
    </div>
  );
}
